import { Newsletter as NewsletterBase } from "./newsletter";

const NewsletterDefault = () => {
    return (
        <div>
            <NewsletterBase.Title />
            <NewsletterBase.Form />
        </div>
    );
};

export { NewsletterDefault };
